import { IActiveDiscountDetail, IAddItemBase, IDiscountDetail } from "@interfaces";
import ftPublicApiClient from "./ftPublicApiClient";
import { AxiosResponse } from "axios";
import ftApiClient from "./ftApiClient";

export const discountApi = {
    getActiveDiscount: (isAuthenticated: boolean) => {
        const url = "/discount/active";
        const client = isAuthenticated ? ftApiClient : ftPublicApiClient;
        return client.get<AxiosResponse<IActiveDiscountDetail>>(url);
    },
    getCartDiscount: () => {
        const url = "/cart/discount/v2?isCart=1";
        return ftApiClient.post<AxiosResponse<IDiscountDetail>>(url);
    },
    getQuoteDiscount: (quoteId: string) => {
        const url = "/cart/discount/v2?quoteId=" + quoteId;
        return ftApiClient.post<AxiosResponse<IDiscountDetail>>(url);
    },
    checkOrderDiscount: (items: IAddItemBase[]) => {
        const url = "/cart/discount/v2?dry=1";
        return ftApiClient.post<AxiosResponse<IDiscountDetail>>(url, items);
    },
};
